module.exports = __webpack_public_path__ + "img/side-icon1.76947db0.png";